<div class="flex h-full flex-1 flex-col place-content-center items-stretch justify-between">
  <h2 [class.login-regular-title]="!isI4BLogin()" [class.layout-login-regular-title]="isI4BLogin()">{{ 'LOGIN.TITLE.GET_CODE' | translate }}</h2>

  @if (!isI4BLogin()) {
    <p class="login-get-code-message">{{ 'LOGIN.HELP_MESSAGE.GET_CODE' | translate }}</p>
  }

  <form [formGroup]="form" [class.login-form-i4b]="isI4BLogin()" class="flex flex-col">
    <mat-form-field color="accent" class="w-full">
      <mat-icon matPrefix>email</mat-icon>
      <mat-label>{{ 'LOGIN.EMAIL' | translate }}</mat-label>
      <input #emailInput (input)="onChangeEmail(emailInput.value)" formControlName="email" matInput type="email" />
      @if (email.invalid) {
        <mat-error>{{ (email?.errors?.email ? 'FORM.ERROR_MESSAGE.INVALID_EMAIL' : 'LOGIN.ERROR_MESSAGE.EMAIL') | translate }}</mat-error>
      }
    </mat-form-field>

    <div [class.error]="hasError()" class="layout-login-error">
      <em>{{ 'LOGIN.ERROR_MESSAGE.INCORRECT_EMAIL' | translate }}</em>
    </div>
    @if (isI4BLogin()) {
      <p class="login-get-code-message-i4b">{{ 'LOGIN.HELP_MESSAGE.GET_CODE' | translate }}</p>
    }

    <div [class.layout-form-actions]="isI4BLogin()" [class.layout-login-form-actions]="!isI4BLogin()">
      <button (click)="onCancel()" class="layout-login-button" mat-button type="button">{{ 'LOGIN.BUTTON.CANCEL' | translate }}</button>
      <button
        (click)="onSendCode()"
        [disabled]="!form.valid"
        class="layout-login-button layout-login-button--submit"
        color="accent"
        mat-raised-button
        type="submit"
      >
        {{ 'LOGIN.BUTTON.SEND_CODE' | translate }}
      </button>
    </div>
  </form>
  <span class="flex-1"></span>
</div>
